/* tslint:disable */
/* eslint-disable */
/**
 * Content-A service
 * Content Service API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-Content_Team@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApiAnalytics
 */
export interface ApiAnalytics {
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  creativeId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  creativeName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  dataAnalyticsAudienceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  dataAnalyticsContentSource: string;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  dataAnalyticsDimension119?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  dataAnalyticsDimension120?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  dataAnalyticsDimension121?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  dataAnalyticsDimension123?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  dataAnalyticsExperimentId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  dataAnalyticsPermanentCreativeId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  dataAnalyticsSourceView?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  dataAnalyticsTargetSegment?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  dataAnalyticsTreatmentId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  eventLabel?: string;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  listType?: string;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  pageName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  pageType?: string;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  placementSlotUid?: string;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  position?: string;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  promoName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  widgetId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  widgetType?: string;
  /**
   *
   * @type {string}
   * @memberof ApiAnalytics
   */
  widgetTypeValue?: string;
}

export function ApiAnalyticsFromJSON(json: any): ApiAnalytics {
  return ApiAnalyticsFromJSONTyped(json, false);
}

export function ApiAnalyticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiAnalytics {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    creativeId: !exists(json, 'creativeId') ? undefined : json['creativeId'],
    creativeName: !exists(json, 'creativeName') ? undefined : json['creativeName'],
    dataAnalyticsAudienceId: !exists(json, 'data-analytics-audience-id')
      ? undefined
      : json['data-analytics-audience-id'],
    dataAnalyticsContentSource: json['data-analytics-content-source'],
    dataAnalyticsDimension119: !exists(json, 'data-analytics-dimension119')
      ? undefined
      : json['data-analytics-dimension119'],
    dataAnalyticsDimension120: !exists(json, 'data-analytics-dimension120')
      ? undefined
      : json['data-analytics-dimension120'],
    dataAnalyticsDimension121: !exists(json, 'data-analytics-dimension121')
      ? undefined
      : json['data-analytics-dimension121'],
    dataAnalyticsDimension123: !exists(json, 'data-analytics-dimension123')
      ? undefined
      : json['data-analytics-dimension123'],
    dataAnalyticsExperimentId: !exists(json, 'data-analytics-experiment-id')
      ? undefined
      : json['data-analytics-experiment-id'],
    dataAnalyticsPermanentCreativeId: !exists(json, 'data-analytics-permanent-creative-id')
      ? undefined
      : json['data-analytics-permanent-creative-id'],
    dataAnalyticsSourceView: !exists(json, 'data-analytics-source-view')
      ? undefined
      : json['data-analytics-source-view'],
    dataAnalyticsTargetSegment: !exists(json, 'data-analytics-target-segment')
      ? undefined
      : json['data-analytics-target-segment'],
    dataAnalyticsTreatmentId: !exists(json, 'data-analytics-treatment-id')
      ? undefined
      : json['data-analytics-treatment-id'],
    eventLabel: !exists(json, 'eventLabel') ? undefined : json['eventLabel'],
    listType: !exists(json, 'listType') ? undefined : json['listType'],
    pageName: !exists(json, 'pageName') ? undefined : json['pageName'],
    pageType: !exists(json, 'pageType') ? undefined : json['pageType'],
    placementSlotUid: !exists(json, 'placementSlotUid') ? undefined : json['placementSlotUid'],
    position: !exists(json, 'position') ? undefined : json['position'],
    promoName: !exists(json, 'promoName') ? undefined : json['promoName'],
    widgetId: !exists(json, 'widgetId') ? undefined : json['widgetId'],
    widgetType: !exists(json, 'widgetType') ? undefined : json['widgetType'],
    widgetTypeValue: !exists(json, 'widgetTypeValue') ? undefined : json['widgetTypeValue'],
  };
}

export function ApiAnalyticsToJSON(value?: ApiAnalytics | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    creativeId: value.creativeId,
    creativeName: value.creativeName,
    'data-analytics-audience-id': value.dataAnalyticsAudienceId,
    'data-analytics-content-source': value.dataAnalyticsContentSource,
    'data-analytics-dimension119': value.dataAnalyticsDimension119,
    'data-analytics-dimension120': value.dataAnalyticsDimension120,
    'data-analytics-dimension121': value.dataAnalyticsDimension121,
    'data-analytics-dimension123': value.dataAnalyticsDimension123,
    'data-analytics-experiment-id': value.dataAnalyticsExperimentId,
    'data-analytics-permanent-creative-id': value.dataAnalyticsPermanentCreativeId,
    'data-analytics-source-view': value.dataAnalyticsSourceView,
    'data-analytics-target-segment': value.dataAnalyticsTargetSegment,
    'data-analytics-treatment-id': value.dataAnalyticsTreatmentId,
    eventLabel: value.eventLabel,
    listType: value.listType,
    pageName: value.pageName,
    pageType: value.pageType,
    placementSlotUid: value.placementSlotUid,
    position: value.position,
    promoName: value.promoName,
    widgetId: value.widgetId,
    widgetType: value.widgetType,
    widgetTypeValue: value.widgetTypeValue,
  };
}
